import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { toast } from 'react-toastify'
import bootbox from 'bootbox'

import { appendModel, deleteSite, modifyModelAttr } from '../../../../features/site/siteSlice'
import { allowedSiteTypes } from '../../../utils/common'
import { addSite, deleteSiteById, updateSite } from '../../../utils/Organizations'
import SidePanelToggle from '../../Layout/Common/SidePanelToggle'
import RegionUsers from '../UserTypes/RegionUsers'
import { getUsers } from '../../../utils/Users'

const INITIAL_STATE = {
    userServicePanel: false,
    filteredSites: [],
    selectedSites: {},
    linkSiteSearch: "",
    allSites: []
}

function RegionModification(props){
    const dispatch = useDispatch()

    const [state, setState] = useState(INITIAL_STATE)
    const isAdmin = useSelector(state => state.session.isAdmin)
    const model = useSelector(state => state.site.model)

    useEffect(() => {
        const brandMap = model.organizations.reduce((map, org, index, arr) => {
            map[org.siteId] = org?.name ?? ""
            return map
        }, {})

        const allSites = model.all
            .filter(x => x.type === 'SITE')
            .filter(x => {
                if(model?.regForm?.franDevOnly){
                    return x?.attr?.isFranchise
                }

                return true
            })
            .map(site => {
                let brandSiteId = site.sitePath.split("/")[2]
                let brandName = ""
                if(brandSiteId !== undefined){
                    brandName = brandMap[brandSiteId] ? brandMap[brandSiteId] : ""
                }

                return {
                    ...site,
                    brandName
                }
            })

        const filteredSites = allSites.sort((a, b) => {
            if(a.brandName === b.brandName){
                return (a.name > b.name) ? 1 : -1
            }
            return (a.brandName > b.brandName) ? 1 : -1
        })

        setState(prev => ({
            ...prev,
            brandMap,
            allSites,
            filteredSites
        }))

    }, [])


    useEffect(() => {
        if(state.userServicePanel){
            getUsers(model.regForm.siteId).then(({response, error}) => {
                if(response){
                    dispatch(appendModel({
                        users: response.users || []
                    }))
                } else {
                    dispatch(appendModel({
                        users: []
                    }))
                }
            })
        }
    }, [state.userServicePanel])

    const onChange = (property="attr", bool=false) => (e) => {
        let modelCopy = {regForm: {...model.regForm}}
        
        if(property){
            modelCopy.regForm[property] = {
                ...modelCopy.regForm[property],
                [e.target.name]: bool ? !modelCopy.regForm[property][e.target.name] : e.target.value
            }
        } else {
            modelCopy.regForm[e.target.name] = bool ? !modelCopy.regForm[e.target.name] : e.target.value
        }
        dispatch(modifyModelAttr({
            key: "regForm",
            body: modelCopy.regForm
        }))
    }

    const saveSite = async() => {
        if(model.regForm?.siteId) {
            let sForm = {
                ...model.regForm
            }

            if(sForm?.linkedSites &&
                sForm?.linkedSiteNickNames === undefined){
                    sForm.linkedSiteNickNames = {}
                }

            await updateSite(sForm?.siteId, null, {
                site: sForm
            })

            let all = [...model.all]

            const allIdx = all.findIndex(a => a.siteId === sForm.siteId)

            if(allIdx){
                all[allIdx] = sForm
            }

            let regions = [...model.regions]

            regions[model.regActiveIdx] = sForm

            dispatch(appendModel({
                regions,
                all,
                regForm: sForm
            }))

            toast.success("Update successful", {containerId: "defaultToastContainer"})
        } else {
            let sForm = {
                ...model.regForm
            }

            if(sForm.linkedSites &&
                sForm.linkedSiteNickNames === undefined){
                    sForm.linkedSiteNickNames = {}
                }

            let org = model?.organizations[model?.orgActiveIdx]

            sForm.sitePath = org.sitePath
            
            const {response, error} = await addSite(null, {
                site: sForm
            })

            sForm.siteId = response.siteId
            sForm.sitePath += '/'+sForm.siteId

            dispatch(appendModel({
                regions: [...model.regions, {...sForm}],
                all: [...model.all, {...sForm}],
                regForm: sForm,
                regActiveIdx: model.regions.length
            }))
            
            toast.success("Site has been created successfully", {containerId: "defaultToastContainer"})
        }

    }

    const linkSites = async() => {
        let { selectedSites, token, filteredSites } = state

        const selectedRegion = model.regForm
        const currentLinkedSites = selectedRegion.linkedSites && Array.isArray(selectedRegion.linkedSites) ? selectedRegion.linkedSites : []

        const siteIds = Object.keys(selectedSites).filter(k => selectedSites[k])

        if(siteIds.length > 0){
            const { response, error } = await updateSite(selectedRegion.siteId, token, {
                site: {
                    ...selectedRegion,
                    linkedSites: [
                        ...new Set([
                            ...currentLinkedSites,
                            ...siteIds
                        ])
                    ]
                }
            })

            if(response && response.errorMessage === undefined){
                let regs = [...model.regions]

                regs[model?.regActiveIdx] = {
                    ...selectedRegion,
                    linkedSites: [
                        ...new Set([
                            ...currentLinkedSites,
                            ...siteIds
                        ])
                    ]
                }

                dispatch(appendModel({
                    regions: [...regs],
                    regForm: {
                        ...selectedRegion,
                        linkedSites: [
                            ...new Set([
                                ...currentLinkedSites,
                                ...siteIds
                            ])
                        ],
                        linkedSiteNickNames: {...new Set([
                            ...currentLinkedSites,
                            ...siteIds
                        ]).values().reduce((prev, curr) => {
                            if(selectedRegion?.linkedSiteNickNames[curr] === undefined)
                                prev[curr] = ""

                            return prev
                        }, {
                            ...(selectedRegion?.linkedSiteNickNames ?? {})
                        })}
                    }
                }))
                toast.success("Sites have been linked to region!", {containerId: "defaultToastContainer"})

                filteredSites = filteredSites.filter(site => !siteIds.includes(site.siteId))

                setState(prevState =>({
                    ...prevState,
                    selectedSites: {},
                    filteredSites,
                    linkedSites: [
                        ...currentLinkedSites,
                        ...siteIds
                    ]
                }))
            } else {
                toast.error("Error occurred", {containerId: "defaultToastContainer"})
            }
        } else {
            toast.warn("You must select at least one site", {containerId: "defaultToastContainer"})
        }
    }

    const deleteSiteLink = async(siteId) => {
        let { filteredSites, token, selectedSites } = state

        let sitesLinked = model.regForm?.linkedSites?.filter(sId => siteId !== sId).map(sId => {
            return model.all.find(x => x.siteId === sId).siteId ?? ""
        })

        toast.success("Site link deleted successfully!", {containerId: "defaultToastContainer"})

        filteredSites.unshift({
            ...model.all.find(site => site.siteId === siteId)
        })

        const selectedRegion = model.regForm

        if(sitesLinked.length > 0){
            const { response, error } = await updateSite(selectedRegion.siteId, token, {
                site: {
                    ...selectedRegion,
                    linkedSites: [
                        ...new Set([
                            ...sitesLinked
                        ])
                    ]
                }
            })

            if(response && response.errorMessage === undefined){
                let regs = [...model.regions]

                regs[model?.regActiveIdx] = {
                    ...selectedRegion,
                    linkedSites: [
                        ...new Set([
                            ...sitesLinked
                        ])
                    ]
                }

                dispatch(appendModel({
                    regions: [...regs],
                    regForm: {
                        ...selectedRegion,
                        linkedSites: [
                            ...new Set([
                                ...sitesLinked
                            ])
                        ]
                    }
                }))
            }
        }

        setState(prevState => ({
            ...prevState,
            filteredSites,
            sitesLinked
        }))
    }

    const handleSiteSelect = (site, e) => {
        const value = !state.selectedSites[site.siteId] ?? true

        setState(prevState => ({
            ...prevState,
            selectedSites: {
                ...prevState.selectedSites,
                [site.siteId]: value
            }
        }))
    }

    const onLinkSiteSearch = (search) => {
        const { allSites } = state
        let filteredSites = []
        if(search.length > 2){
            filteredSites = allSites.filter(site => {
                return model.regForm?.linkedSites && Array.isArray(model.regForm?.linkedSites) ? !model.regForm?.linkedSites.includes(site.siteId) &&
                    site.brandName.toLowerCase().includes(search.toLowerCase()) || site.name.toLowerCase().includes(search.toLowerCase()) :
                    site.brandName.toLowerCase().includes(search.toLowerCase()) || site.name.toLowerCase().includes(search.toLowerCase())
            })
        } else if(search.length <= 2 ){
            filteredSites = model.regForm?.linkedSites && Array.isArray(model.regForm?.linkedSites) ? allSites.filter(site => !model.regForm?.linkedSites.includes(site.siteId)) : allSites
        }

        setState(prevState => ({
            ...prevState,
            filteredSites: filteredSites.sort((a, b) => {
                if(a.brandName === b.brandName){
                    return (a.name > b.name) ? 1 : -1
                }
                return (a.brandName > b.brandName) ? 1 : -1
            }),
            linkSiteSearch:search
        }))
    }

    const toggleSelectAll = () => {
        const { filteredSites, selectedSites } = state
        let toggle = true

        if(Object.values(selectedSites)[0]){
            toggle = false
        }

        setState(prevState => ({
            ...prevState,
            selectedSites: filteredSites.reduce((prev, curr) => {
                prev[curr.siteId] = toggle

                return prev
            }, {})
        }))
    }


    const onDelete = async() => {
        bootbox.confirm({
            size: "small",
            title: `Corfirmation`,
            message: `Are you sure you want to delete ${model.regForm.name}?`,
            buttons: {
                cancel: {
                    label: '<i class="fa fa-times"></i> No'
                },
                confirm: {
                    className: 'btn-danger',
                    label: '<i class="fa fa-check"></i> Yes'
                }
            },
            callback: async function (result) {
                if(result){

                    const {response, error } = await deleteSiteById(model?.regForm?.siteId)
                    
                    if(response){
                        props.onDeleteSite(model?.regForm?.siteId, "REG")
                        toast.success("Region has been deleted", {containerId: "defaultToastContainer"})

                        dispatch(deleteSite({
                            siteId: model?.regForm?.siteId, 
                            siteType: "REG"
                        }))
                    }
                }
            }
        });

    }

    const { regForm } = model

    const { 
        selectedSites, 
        linkSiteSearch,
        filteredSites,
        allSites
    } = state

    const inputDisabled = model.reseller && model.isAffiliate ? true : false

    return <>
        <div class="card card-raised h-100">
            <div class="card-body p-20">
                <div className="d-flex justify-content-between align-items-center">
                    <div class="overline text-muted mb-4">Region</div>
                    <div className="d-none d-sm-none d-md-none d-lg-block d-xl-block">
                        {(!model.reseller || (model.reseller && !model.isAffiliate)) && <div className="btn-group mr-2">
                            <button className="btn btn-lg btn-primary" onClick={() => saveSite()}>
                                <i class="fas fa-save"></i> Save
                            </button>
                            {!model.orgFixed && regForm?.siteId && <button className="btn btn-lg btn-outline-danger" id="regionDeleteBtn" onClick={() => onDelete()}>
                                <i class="fas fa-trash-alt"></i> Delete
                            </button>}
                        </div>}
                        <div className="btn-group">
                            {regForm?.siteId && <button className="btn btn-lg btn-outline-info" onClick={e => setState(prev => ({...prev, userServicePanel: true}))}>
                                <i class="fas fa-user-alt"></i> Users
                            </button>}
                        </div>
                    </div>
                    <div className="d-block d-sm-block d-md-block d-lg-none d-xl-none">
                        <div className="btn-group mr-2">
                            <button className="btn btn-outline-primary" onClick={() => props.onGoBack()}>
                                <i class="fas fa-chevron-circle-left"></i> Back
                            </button>
                            <button className="btn btn-primary" onClick={() => saveSite()}>
                                <i class="fas fa-save"></i> Save
                            </button>
                            {!model.orgFixed && regForm?.siteId && <button className="btn btn-outline-danger" id="regionDeleteBtn" onClick={() => onDelete()}>
                                <i class="fas fa-trash-alt"></i> Delete
                            </button>}
                        </div>
                        <div className="btn-group">
                            {regForm?.siteId && <button className="btn btn-outline-info" onClick={e => setState(prev => ({...prev, userServicePanel: true}))}>
                                <i class="fas fa-user-alt"></i> Users
                            </button>}
                        </div>
                    </div>
                </div>
                <h1 className="d-none d-sm-none d-md-none d-lg-block d-xl-block">{regForm?.name}</h1>
                <h2 className="d-block d-sm-block d-md-block d-lg-none d-xl-none">{regForm?.name}</h2>
                <form class="form-horizontal">
                    <div class="form-group row m-b-10">
                        <label class="col-form-label col-sm-3" for="fullname">Region Name:</label>
                        <div class="col-sm-6">
                            <input type="text" class="form-control" name="name" value={regForm?.name} onChange={onChange(null)} disabled={inputDisabled} />
                        </div>
                    </div>
                    {!regForm?.siteId && <div class="form-group row m-b-10">
                        <label class="col-form-label col-sm-3" for="linkedinSites">Allow Linked Sites:</label>
                        <div class="col-sm-6 d-flex align-self-center">
                            <input type="checkbox" 
                                name="linkedSites" 
                                checked={regForm?.linkedSites ? "checked": ""} 
                                onChange={onChange(null, true)} />
                        </div>
                    </div>}
                    {(regForm?.linkedSites) && <div class="form-group row m-b-10">
                        <label class="col-form-label col-sm-3" for="fullname">FranDev Only Sites:</label>
                        <div class="col-sm-6 d-flex align-self-center">
                            <input type="checkbox" 
                                name="franDevOnly" 
                                checked={regForm?.franDevOnly ? "checked": ""} 
                                onChange={onChange(null, true)} />
                        </div>
                    </div>}

                    {(regForm.siteId && regForm.linkedSites && (!model.orgFixed || (model.userSite && allowedSiteTypes.includes(model.userSite.type)))) && <div class="form-group row m-b-10">
                        <div class="col-lg-6">
                            <div class="card">
                                <div class="position-absolute" style={{right:"5px"}}>
                                    <div class="form-inline">
                                        <button class="btn btn-sm btn-primary" type="button" onClick={() => toggleSelectAll()}>Select All</button>
                                        <input class="form-control" type="text" value={linkSiteSearch} onChange={e => onLinkSiteSearch(e.target.value)} />
                                        <button class="btn btn-primary" type="button" onClick={() =>linkSites()}>Link Sites</button>
                                    </div>
                                </div>
                                <div class="card-body">
                                    <div class="form mt-sm-3" style={{height: "400px",overflow: "auto"}}>
                                        {filteredSites.map(site => <div class="form-check">
                                            <input type="checkbox" 
                                                class="form-check-input" 
                                                onChange={e => handleSiteSelect(site, e)} 
                                                checked={selectedSites[site.siteId] ? "checked": false}
                                            />
                                            <label class="form-check-label" htmlFor="siteItem">{site.brandName}: {site.name}</label>
                                        </div>)}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className={`${!model.orgFixed || allowedSiteTypes.includes(model.userSite.type) ? 'col-lg-6' : ''} ${model.orgFixed && !model.singleSiteUser && model.userSite && model.userSite.type === 'REG' ? 'col-lg-12' : ""}`}>
                            <div class="table-responsive">
                                <table class="table table-hover">
                                    <thead>
                                        <tr>
                                            <th>Brand Name</th>
                                            <th>Site Name</th>
                                            <th>Nick Name</th>
                                            <th>&nbsp;</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {Array.isArray(regForm.linkedSites) && regForm.linkedSites.map((siteId, idx) => {
                                            const site = model.all.find(s => s.siteId === siteId)
                                            const brand = model.organizations.find(brd => site && site?.sitePath.includes(brd.sitePath))
                                            return <tr key={siteId}>
                                                <td>{ brand?.name ?? "Not Defined" }</td>
                                                <td>{ site?.name ?? "Not Defined" }</td>
                                                <td>
                                                    <input className="form-control" name={siteId} onChange={onChange("linkedSiteNickNames")} value={regForm?.linkedSiteNickNames ? regForm?.linkedSiteNickNames[siteId] : ""} />
                                                </td>
                                                <td align="right">
                                                    <a href onClick={() => deleteSiteLink(siteId)}>
                                                        <i className="far fa-trash-alt fa-lg"></i>
                                                    </a>
                                                </td>
                                            </tr>
                                        })}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>}
                </form>
            </div>
        </div>
        <SidePanelToggle autoCloseOnBlur overrideActiveState={state.userServicePanel} showIconOnActive onClick={() =>setState(prev => ({...prev, userServicePanel: false}))}>
            <RegionUsers />
        </SidePanelToggle>
    </>
}

export default RegionModification